import Modal from '../../../../shared/Modal'
import Button from '../../../../shared/Buttons/Button'
import { useState } from 'react'
import css from './createImageOptionModal.module.css'
import Checkbox from '../../../../shared/Checkbox'
import Dropzone from '../../../../shared/Dropzone/PngDropzone'
import { IDraftImage } from '../../../../types/tasks.types'

interface IProps {
  onClose: () => void
  onCreate: (option: IDraftImage) => void
  isAnswer?: boolean
}

const CreateImageOptionModal = (props: IProps) => {
  const [right, setRight] = useState(false)
  const [file, setFile] = useState(null)

  const handleCreate = () => {
    props.onCreate({ imageFile: file, rightAnswer: right })
  }

  return (
    <Modal onClose={props.onClose} size="lg">
      <div className={css.wrapper}>
        <div className={css.form}>
          <div className={css.dropzone}>
            <Dropzone onFile={setFile} />
          </div>
          {props.isAnswer !== false && (
            <Checkbox checked={right} onChange={setRight} inscription="Правильный ответ" name="right" />
          )}
        </div>
        <div className={css.footer}>
          <Button onClick={handleCreate}>Добавить</Button>
        </div>
      </div>
    </Modal>
  )
}

export default CreateImageOptionModal
